<app-modal #successModal [modalConfig]="modalConfig">
  <div class="modal-header">
    <button type="button" class="close btn-sm" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center py-5">
    <div class="success-icon-container mb-4">
      <div class="host-offers separator-right">
        <img class="icon" src="assets/images/icons/Check.svg" alt="Success" />
      </div>
    </div>
    <h2 class="success mb-4">
      <p i18n> Success </p>
    </h2>
    <p class="success-message mb-4" i18n> {{ txtMessage }} </p>
    <button type="button" class="btn btn-success btn-continue" (click)="onClose()">
      {{ buttonText }}
    </button>
  </div>
</app-modal>
